import { Skeleton } from '@nest/uikit-react';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useNavigate } from 'react-router';
import { useTerminalClient } from '../client-rpc-router';
import { TerminalScreen } from '../components/TerminalScreen';
import { useCommandOpenScanPackagePage } from './consignment-notes/commands/consignment-notes-open-scan-package.command';

export default function ConsignmentNotesCarriersPage() {
	const client = useTerminalClient();
	const navigate = useNavigate();
	const commands = [useCommandOpenScanPackagePage()];

	const carrierQuery = useQuery({
		queryKey: ['my-warehouse-carriers'],
		queryFn: () => client.wms.getMyWarehouseCarriersQuery.execute({})
	});

	const carrierIds = useMemo(() => carrierQuery.data?.map(c => c.id) ?? [], [carrierQuery.data]);

	const countsQuery = useQuery({
		queryKey: ['packed-not-in-container-counts', carrierIds],
		queryFn: () => client.consignmentNotes.countPackedPackageUnitsWithoutContainerByCarrierQuery.execute({ carrierIds }),
		enabled: carrierIds.length > 0
	});

	const countsMap = useMemo(() => new Map<number, number>((countsQuery.data ?? []).map(x => [x.carrierId, x.count])), [countsQuery.data]);

	return (
		<TerminalScreen showBackButton topBar={<div>Dopravci</div>} commands={commands}>
			<div className="p-2 flex flex-col gap-2">
				{carrierQuery.isLoading ? (
					<div className="space-y-2">
						<Skeleton className="h-10 w-full" />
						<Skeleton className="h-10 w-full" />
					</div>
				) : (
					carrierQuery.data?.map(carrier => (
						<button
							key={carrier.id}
							className="w-full text-left border rounded p-2 hover:bg-muted/50"
							onClick={() => navigate(`/consignment-notes/carriers/${carrier.id}/list`)}
						>
							<div className="font-medium">{carrier.name}</div>
							<div className="text-muted-foreground">Zabalené mimo kontejner: {countsMap.get(carrier.id) ?? ''}</div>
						</button>
					))
				)}
			</div>
		</TerminalScreen>
	);
}
